import { Injectable } from '@angular/core';
import {
    EntityCollectionServiceBase,
    EntityCollectionServiceElementsFactory,
} from 'ngrx-data';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LoginService } from 'src/app/login/services/login-service.service';

import { HttpClient } from '@angular/common/http';
import { ACLServiceWeb } from '../ACLServices-web.service';
import { LegalCounsel } from './legal-counsel.dto';

@Injectable({
  providedIn: 'root'
})
export class LegalCounselService  extends EntityCollectionServiceBase <
LegalCounsel
>{

  private currentEntities: LegalCounsel[];
    constructor(
        serviceElementsFactory: EntityCollectionServiceElementsFactory,
        private loginServce: LoginService,
        private aclServices: ACLServiceWeb
    ) {
        super('LegalCounsel', serviceElementsFactory);
        // console.log('Legal Counsel Service Constructed');

        this.entities$.subscribe(v => (this.currentEntities = v));

        loginServce.loggedIn$.subscribe(v => {
            console.log('User logged in, loading object stores');
            this.clearCache();
            this.getAll();
        });

        loginServce.loggedOut$.subscribe(v => {
            console.log('User logged out, clearing cache');
            this.clearCache();
        });
    }

    getAll$ = null;

    getAll(): Observable<LegalCounsel[]> {
        if (this.currentEntities && this.currentEntities.length > 0) {
            return of(this.currentEntities);
        } else {
            if (this.getAll$ == null) {
                this.getAll$ = super.getAll();
            }
            return this.getAll$;
        }
    }

    getByKey(input) {
        return this.entities$.pipe(
            map(v => v.find(row => row.id === Number(input)))
            // tap(v => console.log('RESULT', v))
        );
    }
    
    getLegalCounselById(key): Observable<LegalCounsel> {
        return this.aclServices.getLegalCounselById(key);
    }

    delete(input): Observable<any> {
        return super.delete(input.email);
    }
}
